export const API_HOST = "registration.elipd.org";
export const API_PORT = "442";

export const API_URL = `https://${API_HOST}:${API_PORT}/api/`;
